import { TimeRange } from "../interface/date.interface";

export const months = [
  "1월",
  "2월",
  "3월",
  "4월",
  "5월",
  "6월",
  "7월",
  "8월",
  "9월",
  "10월",
  "11월",
  "12월",
];

export const years = Array.from(
  { length: new Date().getFullYear() - 1960 + 1 },
  (_, i) => 1960 + i
);

export const defaultTimeSlots: TimeRange[] = [
  { startTime: "09:00", endTime: "10:00" },
  { startTime: "09:30", endTime: "10:30" },
  { startTime: "10:00", endTime: "11:00" },
  { startTime: "10:30", endTime: "11:30" },
  { startTime: "11:00", endTime: "12:00" },
  { startTime: "11:30", endTime: "12:30" },
  { startTime: "12:00", endTime: "13:00" },
  { startTime: "12:30", endTime: "13:30" },
  { startTime: "13:00", endTime: "14:00" },
  { startTime: "13:30", endTime: "14:30" },
  { startTime: "14:00", endTime: "15:00" },
  { startTime: "14:30", endTime: "15:30" },
  { startTime: "15:00", endTime: "16:00" },
  { startTime: "15:30", endTime: "16:30" },
  { startTime: "16:00", endTime: "17:00" },
  { startTime: "16:30", endTime: "17:30" },
  { startTime: "17:00", endTime: "18:00" },
];

export const KOREAN_DAYS = ["월", "화", "수", "목", "금", "토", "일"];
